import Typography from 'components/Common/Typography'
import { ReactNode } from 'react'

interface Props {
  label: string | ReactNode
  value: ReactNode
  subValue?: ReactNode
  className?: string
}

const CardRow = ({ label, value, subValue, className }: Props) => {
  return (
    <div className="flex w-full items-center justify-between gap-2">
      <div className="flex flex-1 items-center justify-between">
        <p className="text-xs font-normal leading-4 text-th-fgd-2 fhd:text-sm">
          {label}
        </p>
        <Typography
          font="font-number"
          className="text-xs !font-bold leading-4 text-th-fgd-1 fhd:text-sm"
        >
          {value}
        </Typography>
      </div>
      <div className={`flex w-36 justify-end ${className}`}>
        <p className="max-w-fit text-xs !font-bold leading-4 text-th-fgd-3 fhd:text-sm">
          {subValue}
        </p>
      </div>
    </div>
  )
}
export default CardRow
